// extracted by mini-css-extract-plugin
export default {"portalBodyContainer":"PortalBody_portalBodyContainer__dVorx","portalContentWrapper":"PortalBody_portalContentWrapper__qyMs7"};